import { render, staticRenderFns } from "./AssetAssignmentEdit.vue?vue&type=template&id=6fbcf328"
import script from "./AssetAssignmentEdit.vue?vue&type=script&lang=js"
export * from "./AssetAssignmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports